import React, { useCallback } from 'react';
import type { BottomTabScreenProps } from '@react-navigation/bottom-tabs';
import { useFocusEffect } from '@react-navigation/native';
import { AppScreen } from '../../components/AppScreen';
import { MenuPanel } from '../../components/MenuPanel';
import { ScreenHeader } from '../../components/ScreenHeader';
import type { MainTabParamList } from '../../constants/routes';
import { spacing } from '../../constants/spacing';
import { useAuth } from '../../context/AuthContext';
import { usePendingRequestCount } from '../../context/PendingRequestCountContext';
import { StyleSheet, View } from 'react-native';

type Props = BottomTabScreenProps<MainTabParamList, 'Menu'>;

export function MenuScreen(_props: Props) {
  const auth = useAuth();
  const pendingRequests = usePendingRequestCount();
  const reloadPendingCounts = pendingRequests.reloadPendingCounts;

  useFocusEffect(
    useCallback(() => {
      Promise.resolve(reloadPendingCounts()).catch(() => undefined);
    }, [reloadPendingCounts]),
  );

  return (
    <AppScreen scroll>
      <ScreenHeader
        title="Menu"
        subtitle={
          auth.user?.displayName || auth.user?.username || 'Signed-in user'
        }
        showMenu={false}
      />
      <View style={styles.body}>
        <MenuPanel />
      </View>
    </AppScreen>
  );
}

const styles = StyleSheet.create({
  body: { marginTop: spacing.lg, paddingBottom: spacing.xl, width: '100%' },
});
